import clsx from "clsx"
import DatePicker from "react-datepicker"
import { colors } from "../../colors"
import { CalendarIcon } from "../../icons/calendar"
import { RoundedCloseIcon } from "../../icons/CloseIcon"

interface Props {
    selected?: Date | null
    onChange?: (date: Date) => void
    onClear?: (date: undefined) => void
    disabled?: boolean
    errorLabel?: string
    label?: string
    minDate?: Date
    reducedHeight?: boolean
    placeholder?: string
    required?: boolean
}

export function Calendar(props: Props) {
    const dayClassName = (date: Date) => {
        if (date.getDay() === 0) {
            return "sunday"
        }
        return ""
    }

    const borderColor = props.errorLabel ? colors.red[600] : colors.neutral[300]

    return (
        <div className="text-left" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '4px', width: '100%' }}>
            {
                props.label &&
                <span
                    style={{ fontFamily: "Manrope" }}
                    className={clsx(
                        'text-label-md font-semibold text-brandPrimary-800',
                    )}
                >
                    {props.label}
                    {
                        props.required && <span className='text-red-600'> *</span>
                    }
                </span>}
            <div style={{ display: 'flex', width: '100%' }}>
                <DatePicker
                    placeholderText={props.placeholder}
                    locale="it"
                    dateFormat="d/MM/yyyy"
                    selected={props.selected}
                    showIcon
                    disabled={props.disabled}
                    icon={
                        <div style={{ display: 'flex', alignItems: 'center', height: '100%', paddingTop: 0, paddingBottom: 0, }}>
                            <CalendarIcon size={20} color="black" />
                        </div>
                    }
                    dayClassName={dayClassName}
                    showYearDropdown
                    showMonthDropdown
                    scrollableYearDropdown
                    minDate={props.minDate}
                    customInput={
                        <input
                            className="placeholder:text-neutral-500 placeholder:font-medium placeholder:text-text-md"
                            style={{
                                outline: 0,
                                padding: '0px 40px',
                                marginRight: '10px',
                                gap: '8px',
                                width: '100%',
                                fontFamily: 'Manrope',
                                fontWeight: '500',
                                fontSize: '16px',
                                lineHeight: '20px',
                                height: props.reducedHeight ? '38px' : '48px',
                                backgroundColor: props.disabled ? 'rgba(242,242,250,1)' : 'white',
                                color: props.disabled ? colors.neutral[500] : colors.neutral[700],
                                borderColor,
                            }}
                        />
                    }
                    onChange={(date) => {
                        if (date !== null) {
                            props.onChange && props.onChange(date)
                        }
                    }}
                />
                {
                    props.onClear && (
                        <button className="pl-3" onClick={() => props.onClear && props.onClear(undefined)}>
                            <RoundedCloseIcon />
                        </button>
                    )
                }
            </div>
            {
                props.errorLabel && (
                    <span
                        className={clsx('text-sm font-semibold', {
                            'text-red-500': props.errorLabel,
                            'text-neutral-400': !props.errorLabel,
                        })}
                    >
                        {props.errorLabel}
                    </span>
                )
            }
        </div>
    )
}